module.exports = __webpack_public_path__ + "7daf1a77147b68451d267c57a8fa73e5.png";